<template>
  <div class="banks">
    <Icon class="banks__icon" name="agreement" color="none" :size="60" />
    <h2 class="banks__title">No somos un banco, pero trabajamos con todos</h2>
    <div class="banks__slider">
      <div class="banks__slider-track">
        <div
          class="banks__img-container"
          v-for="(bank, index) in banks[0]"
          :key="index"
        >
          <img
            class="banks__img"
            :alt="'Logo ' + bank.name"
            :src="bank.logo_url"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/lego/components/icons/Icon.vue';

export default {
  components: {
    Icon,
  },
  setup(props, { root }) {
    console.log(root.$page.props.banks);
    
    return {
      banks: root.$page.props.banks,
    };
  },
};
</script>

<style lang="postcss" scoped>
.banks {
  @apply text-center pt-sm sm:pb-xxl lg:pb-xxxl;

  &__icon {
    @apply icon icon-lg icon-agreement mb-xs;
  }

  &__title {
    @apply container uppercase mx-auto text-brand-secondary-medium sm:text-neutral-ultradark style-subtitle-bold lg:style-title-bold lg:max-w-2xl;
  }

  &__slider {
    @apply relative w-full overflow-hidden mt-lg;
  }

  &__slider-track {
    @apply grid grid-cols-4 gap-xs px-xxs;
  }

  &__img {
    @apply w-full max-w-[8.5rem] max-h-[5.5rem];
  }

  &__img-container {
    @apply flex items-center flex-row justify-center shrink-0;
  }
}
</style>
